import { useOutletContext } from "react-router-dom";
import type { MembershipApplicationDetail } from "./queries";

export interface ApplicationOutletContext {
  application: MembershipApplicationDetail;
}

export const useApplicationContext = (): ApplicationOutletContext => {
  return useOutletContext<ApplicationOutletContext>();
};
